import { axios } from "../lib/axios";

export const updatePatient = async function (model) {
  try {
    const response = await axios.put("patient/editpatient", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
